var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };} /** @format */

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getField } from 'react-redux-form';
import { Icon } from "../../UI";

// exported for testing.
export class MultipleEditionFieldWarningBase extends Component {
  render() {
    if (!this.props.touched || !this.props.multipleEdition) {
      return false;
    }
    return /*#__PURE__*/(
      _jsx("span", {}, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "exclamation-triangle" }), "\xA0"));



  }
}






// exported for testing.
export const mapStateToProps = (state, props) => {
  const fieldState = getField(state, `${props.model}.${props.field}`) || { pristine: true };
  let touched = !fieldState.pristine;
  if (fieldState.$form) {
    touched = !fieldState.$form.pristine;
  }
  return { touched };
};

export default connect(mapStateToProps)(MultipleEditionFieldWarningBase);